import { useEffect, useState } from "react";
import { Zap } from "lucide-react";
import { TRV_BASE_PRICE_EUR_KWH, TRV_BASE_SUBSCRIPTION_EUR_MONTH } from "@/config/regulatedReference";
import api from "@/lib/api";

// Valeurs de repli réalistes (TRV CRE 2025) si l'API n'est pas joignable (ex. CORS en local).
const FALLBACK = {
  electricity: {
    trv_base_kwh: TRV_BASE_PRICE_EUR_KWH,
    trv_hp_kwh: 0.27,
    trv_hc_kwh: 0.2068,
    trv_base_subscription_monthly: 14.9,
    market_average_kwh: 0.22,
    green_average_kwh: 0.21,
  },
  gas: { market_average_kwh: 0.11 },
  source: "CRE",
};

function eur(v, dec = 4) {
  if (v == null || isNaN(v)) return null;
  return Number(v).toLocaleString("fr-FR", { minimumFractionDigits: dec, maximumFractionDigits: dec });
}

export default function PriceTicker() {
  const [t, setT] = useState(FALLBACK);

  useEffect(() => {
    let on = true;
    api
      .get("/tariffs/current")
      .then((r) => {
        if (on && r?.data?.electricity) setT((prev) => ({ ...prev, ...r.data }));
      })
      .catch(() => {});
    return () => { on = false; };
  }, []);

  const e = t.electricity || {};
  const g = t.gas || {};
  const items = [
    ["Élec · TRV base", eur(e.trv_base_kwh), "€/kWh"],
    ["Élec · heures pleines", eur(e.trv_hp_kwh), "€/kWh"],
    ["Élec · heures creuses", eur(e.trv_hc_kwh), "€/kWh"],
    ["Élec · prix marché", eur(e.market_average_kwh), "€/kWh"],
    ["Élec · offre verte", eur(e.green_average_kwh), "€/kWh"],
    ["Abonnement base", eur(e.trv_base_subscription_monthly, 2), "€/mois"],
    ["Gaz · prix marché", eur(g.market_average_kwh), "€/kWh"],
  ].filter(([, v]) => v != null);

  const renderLine = (key) =>
    items.map(([label, val, unit], i) => (
      <span key={`${key}-${i}`} className="mx-6 inline-flex shrink-0 items-center gap-2 text-sm">
        <Zap className="h-3.5 w-3.5 shrink-0 text-accent" aria-hidden />
        <span className="text-primary-foreground/70">{label}</span>
        <span className="font-bold text-white tabular-nums">{val}</span>
        <span className="text-xs text-primary-foreground/50">{unit}</span>
        <span className="ml-4 text-primary-foreground/25">•</span>
      </span>
    ));

  return (
    <div className="bg-primary border-y border-white/10" aria-label="Indicateurs de prix de l'énergie">
      <div className="em-marquee py-2.5">
        <div className="em-marquee__track" style={{ animationDuration: "45s" }}>
          {renderLine("a")}
          {renderLine("b")}
          {renderLine("c")}
          {renderLine("d")}
        </div>
      </div>
    </div>
  );
}
